import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#about", label: "About" },
  { href: "#founder", label: "Founder" },
  { href: "#programs", label: "Programs" },
  { href: "#impact", label: "Impact" },
  { href: "#events", label: "Our Work" },
  { href: "#volunteer", label: "Volunteer" },
  { href: "#contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-sand/85 backdrop-blur-xl border-b border-line"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-28 md:h-32 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-3 md:gap-4 group"
        >
          <img
            src="/logos/simple-3-sapling-dot.jpg"
            alt="JRSDWA logo"
            data-testid="nav-logo-img"
            className="w-20 h-20 md:w-24 md:h-24 object-contain bg-cream group-hover:scale-105 transition-transform duration-300"
          />
          <span className="hidden sm:flex flex-col leading-tight">
            <span className="font-serif text-xl md:text-2xl text-ink tracking-tight">
              JRSDWA
            </span>
            <span className="font-serif italic text-sm md:text-base text-graphite -mt-0.5">
              Jharkhand Rastriya Sarva Dharma
            </span>
            <span className="overline text-[10px] mt-1">
              Welfare Association · Est. 2007
            </span>
          </span>
        </a>

        <nav
          className="hidden md:flex items-center gap-8"
          data-testid="nav-links"
        >
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm text-graphite hover:text-terracotta transition-colors relative after:content-[''] after:absolute after:left-0 after:-bottom-1 after:h-px after:w-0 after:bg-terracotta after:transition-all hover:after:w-full"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#donate"
            data-testid="nav-cta-donate"
            className="text-sm bg-terracotta hover:bg-terracotta-hover text-white px-5 py-2.5 transition-colors"
          >
            Donate
          </a>
        </div>

        <button
          className="md:hidden text-ink"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          className="md:hidden bg-cream border-t border-line"
          data-testid="nav-mobile-menu"
        >
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-graphite hover:text-terracotta"
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            ))}
            <a
              href="#donate"
              onClick={() => setOpen(false)}
              className="mt-2 inline-block bg-terracotta text-white px-5 py-3 text-center"
              data-testid="nav-mobile-cta-donate"
            >
              Donate
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
